
angular.module('bmsApp.directives').factory('ComplaintNoteSvc', [
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'COMPLAINT_NOTE_API', function (
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		COMPLAINT_NOTE_API) {

	return {
		index: function (params) {
			return CRUDSvc.post(COMPLAINT_NOTE_API.INDEX, params);
		},
		create: function (complaint) {
			return CRUDSvc.post(COMPLAINT_NOTE_API.CREATE, complaint);
		},
		update: function (complaint) {
			return CRUDSvc.post(COMPLAINT_NOTE_API.UPDATE + complaint.id, complaint);
		},
		delete: function (complaint) {
			return CRUDSvc.get(COMPLAINT_NOTE_API.DELETE + complaint.id);
		},
		showSaveModal: function (complaintNote) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/complaints/templates/ComplaintNoteForm.html',
				controller: 'ComplaintNoteFormCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					complaint: function () {
						return angular.copy(complaintNote);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					var message;
					switch (result.action) {
						case 'create':
							message = 'Comment created successfully';
							break;
						case 'update':
							message = 'Comment updated successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
					$rootScope.$broadcast('complaintsUpdated');
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});
		}
	};

}]).constant('COMPLAINT_NOTE_API', {
	INDEX: 'api/complaint/note/index',
	CREATE: 'api/complaint/note/create',
	UPDATE: 'api/complaint/note/update/',
	DELETE: 'api/complaint/note/delete/'
});
